export default "__VITE_ASSET__D1SY_IYk__"